<template>
  <div>
    <SelectorPanel
      type="cyber"
      text="Cyber"
      :disabled="disabled"
      :force-close="forceClose"
      @open="handlePanelOpen"
    >
      <v-container v-if="isOpen" class="pa-0 hyp-cyber-container">
        <v-row dense row>
          <v-col class="px-0 col-3">
            <SelectorPanelHeader
              type="cyber"
              title="Cyber"
              @click-close="handleClickClose"
            ></SelectorPanelHeader>

            <v-row dense row>
              <v-col class="col-12">
                <CyberListing @selected="handleSelected"></CyberListing>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            v-if="title && body"
            class="col-9 hyp-cyber-details-container"
            ref="container"
          >
            <p class="hyp-cyber-title application-heading">{{ title }}</p>
            <p v-html="body"></p>
          </v-col>
        </v-row>
      </v-container>
    </SelectorPanel>
  </div>
</template>

<script>
import lodashGet from "lodash/get";
import lodashDebounce from "lodash/debounce";

import { EVENT_ACTIONS, EVENT_CATEGORIES } from "@/common/constants/analytics";

import { getCyberInfo } from "@/services/search/cyber.service";

export default {
  name: "CyberSelector",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SelectorPanel: () => import("@/components/common/SelectorPanel"),
    SelectorPanelHeader: () =>
      import("@/components/common/SelectorPanelHeader"),
    CyberListing: () => import("@/components/cyber/CyberListing"),
  },
  data: () => ({
    forceClose: null,
    isOpen: false,
    selected: null,
    details: null,
  }),
  computed: {
    title() {
      if (lodashGet(this.details, "properties.title.en")) {
        return this.details.properties.title.en;
      }
      return null;
    },
    body() {
      if (lodashGet(this.details, "properties.body.en")) {
        return this.details.properties.body.en;
      }
      return null;
    },
  },
  mounted() {},
  methods: {
    handleClickClose() {
      this.forceClose = new Date().toISOString();
    },
    async handlePanelOpen(open) {
      this.isOpen = open;
      if (open) {
        this.refresh = new Date().toISOString();
        await this.handleSelected({
          id: "6da50d2b-ed99-467d-9960-f9561b9035fc",
          hasData: true,
        });
      }
    },
    async handleSelected(item) {
      if (lodashGet(item, "id") && (item.parent || item.hasData)) {
        this.selected = item;
        this.$set(item, "loading", true);
        this.details = await getCyberInfo(item);
        this.$set(item, "loading", false);
        this.handlePageTrackerEvent(
          EVENT_CATEGORIES.cyber,
          EVENT_ACTIONS.changed,
          item.title
        );
      }
    },
    handleClickImg(evt) {
      evt.preventDefault();
      const src = evt.currentTarget.getAttribute("src");
      const newTab = window.open();
      newTab.document.body.innerHTML = `<img src="${src}">`;
    },
  },
  watch: {
    details: {
      handler() {
        lodashDebounce(() => {
          if (lodashGet(this.$refs, "container")) {
            this.$refs.container.querySelectorAll("a").forEach((input) => {
              if (input.getAttribute("data-type") !== "attachment") {
                input.removeAttribute("href");
                const span = document.createElement("span");
                const textNode = document.createTextNode(input.text);
                span.appendChild(textNode);
                input.parentNode.replaceChild(span, input);
              }
            });
            this.$refs.container.querySelectorAll("img").forEach((input) => {
              input.style.width = "300px";
              input.className = "cursor-pointer";
              input.addEventListener("click", this.handleClickImg);
            });
          }
        }, 500)();
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.hyp-cyber-container {
  height: 99vh !important;
  padding: 0 !important;
  width: 1200px;
}
.hyp-cyber-details-container {
  overflow-y: auto;
  height: 98vh !important;
  border-left: 1px solid #e4e4e4;
  padding: 40px;
}
.hyp-cyber-title {
  font-size: 24px;
  margin-bottom: 30px;
}
</style>
